export default __webpack_public_path__ + "static/NY-StandardOperatingProcedures-43d6ecac090de6d62874f978f28b2b3f.pdf";